/** Production route prefixes (no leading slash — matches DashboardSidebar page ids). */

export const INTEGRATIONS_BASE = 'system/integrations';
export const NOTIFICATION_CENTER_BASE = 'system/notification-center';
export const SLACK_BASE = 'system/integrations/slack';

/** Navigate-friendly paths (with leading slash). */
export const integrationPaths = {
  hub: `/${INTEGRATIONS_BASE}`,
  notificationCenter: `/${NOTIFICATION_CENTER_BASE}`,
  notificationCenterRouting: `/${NOTIFICATION_CENTER_BASE}/routing-studio`,
  notificationCenterResources: `/${NOTIFICATION_CENTER_BASE}/resource-groups`,
  notificationCenterMatrix: `/${NOTIFICATION_CENTER_BASE}/destination-matrix`,
  notificationCenterComms: `/${NOTIFICATION_CENTER_BASE}/communication-hub`,
  notificationCenterTickets: `/${NOTIFICATION_CENTER_BASE}/ticketing-hub`,
  notificationCenterAi: `/${NOTIFICATION_CENTER_BASE}/ai-assistant`,
  notificationCenterWarRoom: `/${NOTIFICATION_CENTER_BASE}/war-room`,
  notificationCenterTesting: `/${NOTIFICATION_CENTER_BASE}/testing`,
  slackOverview: `/${SLACK_BASE}/overview`,
  slackWorkspaces: `/${SLACK_BASE}/workspaces`,
  slackChannels: `/${SLACK_BASE}/channels`,
  slackRouting: `/${SLACK_BASE}/routing-studio`,
  slackTemplates: `/${SLACK_BASE}/templates`,
  slackLogs: `/${SLACK_BASE}/logs`,
  slackAnalytics: `/${SLACK_BASE}/analytics`,
  slackHelp: `/${SLACK_BASE}/help`,
  slackTesting: `/${SLACK_BASE}/testing`,
  slackAlertRules: `/${SLACK_BASE}/alert-rules`,
  slackResourceGroups: `/${SLACK_BASE}/resource-groups`,
} as const;
